var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){_vm.confirm(
          'Beware the index of the documents will change. Do you wish to proceed?'
        )
          ? _vm.sort(_vm.session)
          : null}}},[_c('fa-icon',{attrs:{"icon":"sort-numeric-down"}})],1)]},proxy:true},{key:"content",fn:function(){return [_vm._v("\n    Sort documents by date"),_c('br'),_vm._v("(oldest first)\n  ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }